import BillingDetailsSummary from './BillingDetailsSummary';

export const Business = {
  component: BillingDetailsSummary,
  props: {
    billing: {
      customerType: 'BUSINESS',
      legalName: 'Testi Oy',
      country: 'FI',
      postalCode: '00100',
      street: 'Testikatu 1',
      city: 'Helsinki',
      vatNumber: 'FI31503663',
      businessProofRef: null,
    },
  },
  group: 'payment methods',
};

export const Consumer = {
  component: BillingDetailsSummary,
  props: { billing: { customerType: 'CONSUMER', country: 'FI', postalCode: '00100' } },
  group: 'payment methods',
};
